import axios from "axios";
import Cookies from "universal-cookie";
const apiUrl = "http://localhost:5260";
const cookies = new Cookies();

export const addTemplateApi = async (
  url: string,
  name: string,
  content: string
) => {
  const token = cookies.get("authToken");

  try {
    const response = await axios.post(
      `${url}/template/add`,
      {
        Name: name,
        Content: content,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fetchTemplatesApi = async (url: string) => {
  const token = cookies.get("authToken");

  try {
    const response = await axios.get(`${url}/template/gettemplate`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error(error);
    return false;
  }
};

export const fetchTemplateByIdApi = async (url: string, id: string) => {
  const cookies = new Cookies();
  const token = cookies.get("authToken");

  try {
    const response = await axios.get(`${url}/template/gettemplatebyid/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error fetching template by ID:", error);
    return false;
  }
};

export const updateTemplateApi = async (
  url: string,
  id: string,
  name: string,
  content: string
) => {
  const token = cookies.get("authToken");

  try {
    const response = await axios.post(
      `${url}/template/updatetemplate`,
      {
        id: id,
        name: name,
        content: content,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteTemplateApi = async (url: string, id: string) => {
  const token = cookies.get("authToken");

  try {
    const response = await axios.post(
      `${url}/template/deletetemplate`,
      {
        id: id,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
